import React from "react"
import Title from "./Title"
import { FaQuoteRight } from "react-icons/fa"
import { graphql, useStaticQuery } from "gatsby"

const query = graphql`
  {
    allTestimonial {
      nodes {
        id
        text
        author
        role
        platform
        rating
      }
    }
  }
`

const Testimonials = () => {
  const data = useStaticQuery(query)
  const { allTestimonial: { nodes: testimonials } } = data

  return (
    <section className="section bg-grey">
      <Title title="what people say" />
      <div className="section-center testimonials-center">
        {testimonials.map(item => {
          return (
            <article key={item.id} className="testimonial">
              <FaQuoteRight className="testimonial-icon" />
              <p className="testimonial-text">{item.text}</p>
              <p className="testimonial-source">{item.author} — {item.role}</p>
            </article>
          )
        })}
      </div>
    </section>
  )
}

export default Testimonials
